import type { NumberingSeries } from '~/types/user';

import { generateEntryNumber } from '~/utils/string';

import type { DialogHandles, TableActions } from '../NumberingSeriesTable.hooks';

import { getNumberingSeriesType } from '../utils';
import { mobileActionsStyle, mobileCellStyle, mobileHeaderStyle } from './numberingSeriesCell.css';
import { NumberingSeriesNameCell } from './NumberingSeriesNameCell';
import { NumberingSeriesNextNumberCell } from './NumberingSeriesNextNumberCell';
import { NumberingSeriesOptionsCell } from './NumberingSeriesOptionsCell';
import { NumberingSeriesTypeCell } from './NumberingSeriesTypeCell';

type Props = {
  actions: TableActions;
  dialogHandles: DialogHandles;
  numberingSeries: NumberingSeries;
};

export const NumberingSeriesMobileCell = ({ actions, dialogHandles, numberingSeries }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <NumberingSeriesNameCell name={numberingSeries.name} />

        <NumberingSeriesTypeCell type={getNumberingSeriesType(numberingSeries)} />
      </div>

      <div className={mobileActionsStyle}>
        <NumberingSeriesNextNumberCell nextNumber={generateEntryNumber(numberingSeries)} />

        <NumberingSeriesOptionsCell actions={actions} dialogHandles={dialogHandles} numberingSeries={numberingSeries} />
      </div>
    </div>
  );
};
